import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, DatoEntity, FiltrosFormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-seleccion-unica',
  templateUrl: './seleccion-unica.component.html',
  styleUrls: ['./seleccion-unica.component.css']
})
export class SeleccionUnicaComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  descripcion: string;
  options: NodoEntity[] = [];
  groupOptions: any[] = [];

  constructor() { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.descripcion = this.nodo.descripcion;
    if (this.nodo && this.nodo.hijos) {
      const group = [];
      let data = { values : [] };
      this.nodo.hijos.forEach((h: NodoEntity) => {
          if (data.values.length < (this.nodo.codigoOrientacion === 1 ? 2 : 4)) {
            data.values.push(h);
          } else {
            group.push(data);
            data = { values : [ h ] };
          }
      });

      if (data && data.values && data.values.length > 0) {
        group.push(data);
        data = { values : [] };
      }

      this.groupOptions = group;
    }
    this.onValidateEmptyData();
  }

  isChecked(option: NodoEntity) {
    if (this.nodo.datos && this.nodo.datos.length > 0) {
      const dato = this.nodo.datos.find((d: DatoEntity) => Number(d.valor) === option.id );
      return dato ? true : false;
    }
    return false;
  }

  onValidateEmptyData() {
    if (this.filtros.diligenciados) {
      if (!this.nodo.datos || this.nodo.datos.length === 0) {
        this.onDelete();
      }
    }
  }

  onDelete() {}

}
